import { GraphNode } from '../graph-node.js';
const SEQUENCE_PORT_PATTERN = /^exec(?:_(\d+))?$/;
function getSequencePortIndex(portKey) {
    if (portKey === 'exec')
        return 0;
    const match = SEQUENCE_PORT_PATTERN.exec(portKey);
    return Number(match?.[1] ?? Number.MAX_SAFE_INTEGER);
}
export class SequenceNode extends GraphNode {
    async run() {
        super.run();
        const outputKeys = [...this.outConnections.keys()]
            .filter((portKey) => SEQUENCE_PORT_PATTERN.test(portKey))
            .sort((left, right) => getSequencePortIndex(left) - getSequencePortIndex(right));
        if (this.data.parallel === true) {
            await Promise.all(outputKeys.map((portKey) => this.runOutPort(portKey)));
            return;
        }
        for (const outputKey of outputKeys) {
            await this.runOutPort(outputKey);
        }
    }
}
